import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';
import SelectField from '../../Forms/Input/SelectField';

import useCashDrawer from '../../../hooks/hardware/useCashDrawer';
import usePrinter from '../../../hooks/hardware/usePrinter';

import {
  closeEditModalAndReset,
  updateCashDrawerField,
} from '../../../store/slices/hardware/cashDrawerSlice';

interface Props {
  isOpen: boolean;
  onUpdate: () => void;
}

const CashDrawerEditPopup: React.FC<Props> = ({ isOpen, onUpdate }) => {
  const dispatch = useDispatch();
  const { form } = useCashDrawer();
  const { list: printers, fetchAllPrinters } = usePrinter();

  useEffect(() => {
    if (isOpen) {
      fetchAllPrinters(); // 🔄 cargar impresoras para el select
    }
  }, [isOpen]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    dispatch(updateCashDrawerField({ field: name as any, value }));
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={() => dispatch(closeEditModalAndReset())}
      title="Editar Cajón de Dinero"
      maxWidth="max-w-3xl"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onUpdate();
        }}
        className="grid grid-cols-1 gap-4 md:grid-cols-2"
      >
        {/* Nombre del Cajón */}
        <InputField
          label="Nombre del Cajón"
          name="name"
          iconKey="list"
          value={form.name}
          onChange={handleChange}
          type="text"
        />

        {/* Impresora Asociada */}
        <SelectField
          label="Impresora"
          name="printerId"
          iconKey="printer"
          value={form.printerId?.toString() ?? ''}
          onChange={handleChange}
          options={printers.map((printer) => ({
            label: printer.name,
            value: printer.id.toString(),
          }))}
          placeholder="Seleccione impresora"
        />

        {/* Comando de Apertura */}
        <InputField
          label="Comando de Apertura"
          name="openCommand"
          iconKey="code"
          value={form.openCommand}
          onChange={handleChange}
          type="text"
        />

        {/* Botón Guardar */}
        <div className="md:col-span-2">
          <button
            type="submit"
            className="w-full rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
          >
            Actualizar Cajón
          </button>
        </div>
      </form>
    </FormModal>
  );
};

export default CashDrawerEditPopup;
